export default function Loading() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/20 backdrop-blur-[2px]">
      <div className="relative w-18 h-18">
        <img 
          src="https://yefranchisees.b-cdn.net/frontend/loader.gif" 
          alt="Loading..." 
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}
